import React from 'react';
import { Hero } from '../components/Hero';
import { ProblemSection } from '../components/ProblemSection';
import { SolutionSection } from '../components/SolutionSection';
import { BenefitsGrid } from '../components/BenefitsGrid';
import { OfferSection } from '../components/OfferSection';
import { Footer } from '../components/Footer';
export function LandingPage() {
  return <main className="w-full min-h-screen bg-cream-primary" data-id="element-162">
      <Hero data-id="element-163" />
      <ProblemSection data-id="element-164" />
      <SolutionSection data-id="element-165" />
      <BenefitsGrid data-id="element-166" />
      <OfferSection data-id="element-167" />
      <Footer data-id="element-168" />
    </main>;
}